export default "__VITE_ASSET__DXq8$_6E__"